<mat-icon [matMenuTriggerFor]="Notification"
          matBadge="{{UnreadCount}}"
          matBadgeColor="warn"
          [ngClass]="{ 'bell-alert': UnreadCount > 0, 'bell-ring': RingBell }"
          class="notif-bell"
          matRipple
          matRippleColor="rgba(0,0,0,0.2)">
  notifications
</mat-icon>
<mat-menu #Notification="matMenu">
  @if(Notifications.length > 0){
    @for(n of Notifications; track $index){
      <div class="notification-row"><button mat-menu-item (click)="openNotification(n)"><strong>{{n.Title}}</strong><small style="display:block;white-space:normal">{{n.Message}}</small></button><button mat-icon-button (click)="$event.stopPropagation(); DeleteNotification(n)" aria-label="Dismiss notification"><mat-icon>close</mat-icon></button></div>
    }
    }
    @if(Notifications.length === 0){
    <ng-container>
      <div style="padding: 1rem; opacity: .6;">No notifications</div>
    </ng-container>
    }
</mat-menu>
